import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';
import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import state from './state';

export const serviceComputed = {
	...mapState('loginHistoryStore', Object.keys(state)),
	...mapGetters('loginHistoryStore', Object.keys(getters))
};
export const serviceMethods = {
	...mapActions('loginHistoryStore', Object.keys(actions)),
	...mapMutations('loginHistoryStore', Object.keys(mutations))
};
